// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__VxQmn","close":"style_close__9LEQT","dark":"style_dark__EsFST"};